import { Head, useForm } from '@inertiajs/react';
import { useState } from 'react';

import { Btn } from '@/Components/Btn';
import { PublicLayout } from '@/Layouts/PublicLayout';

type FormShape = {
    code: string;
    recovery_code: string;
};

export default function TwoFactor() {
    const [mode, setMode] = useState<'totp' | 'recovery'>('totp');
    const form = useForm<FormShape>({
        code: '',
        recovery_code: '',
    });

    function submit(e: React.FormEvent) {
        e.preventDefault();
        form.post('/two-factor-challenge');
    }

    return (
        <PublicLayout>
            <Head title="Two-factor authentication" />
            <div className="max-w-md mx-auto px-6 py-12">
                <h1 className="text-[28px] leading-tight text-ink mb-3">Two-factor authentication</h1>
                <p className="text-ink-soft text-[14px] mb-6">
                    {mode === 'totp'
                        ? 'Open your authenticator app and enter the 6-digit code.'
                        : 'Enter one of your recovery codes.'}
                </p>

                <form onSubmit={submit} className="space-y-4">
                    {mode === 'totp' ? (
                        <input
                            type="text"
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            pattern="[0-9]*"
                            required
                            value={form.data.code}
                            onChange={(e) => form.setData('code', e.target.value)}
                            className="w-full p-3 border border-rule rounded bg-card text-center text-[20px] tracking-widest"
                            placeholder="000000"
                        />
                    ) : (
                        <input
                            type="text"
                            autoComplete="off"
                            required
                            value={form.data.recovery_code}
                            onChange={(e) => form.setData('recovery_code', e.target.value)}
                            className="w-full p-3 border border-rule rounded bg-card"
                            placeholder="abcdef-123456"
                        />
                    )}

                    {(form.errors.code || form.errors.recovery_code) && (
                        <p className="text-[12px] text-red-700">
                            {form.errors.code ?? form.errors.recovery_code}
                        </p>
                    )}

                    <Btn type="submit" full loading={form.processing}>
                        Verify
                    </Btn>

                    <button
                        type="button"
                        onClick={() => setMode((m) => (m === 'totp' ? 'recovery' : 'totp'))}
                        className="text-[13px] text-ember underline mt-2"
                    >
                        {mode === 'totp' ? 'Use a recovery code' : 'Use your authenticator app'}
                    </button>
                </form>
            </div>
        </PublicLayout>
    );
}
